/**
 * Task T: Base / Full plans, plan switch, comparison table, stock-tracking switch, Platform admin → Plans & add-ons,
 * signup plan choice, marketing-site website section settings. One row per key: [key, English, 中文]. Malay falls back to English.
 */
const ROWS = [
  ["tt.plans.title", "Choose your plan", "选择方案"],
  ["tt.plans.sub", "Base has everything to run your shop. Full adds your website, automatic payroll and the supplier system.", "基础版包含经营门店所需的一切；全功能版再加上网站、自动算薪与供应商系统。"],
  ["tt.plans.current", "Your plan", "当前方案"],
  ["tt.plans.recommended", "Everything included", "全部包含"],
  ["tt.plans.perMonth", "{price} / month", "{price} / 月"],
  ["tt.plans.switchTo", "Switch to {name}", "切换到{name}"],
  ["tt.plans.everythingIn", "Everything in {name}, plus:", "包含{name}全部功能，另加："],
  ["tt.plans.included", "What's included", "包含内容"],
  ["tt.plans.compare", "Compare plans", "方案对比"],
  ["tt.plans.feature", "Feature", "功能"],
  ["tt.plans.yes", "Included", "已包含"],
  ["tt.plans.addonPrice", "Add-on {price} / month", "加购 {price} / 月"],
  ["tt.plans.no", "Not available", "不提供"],
  ["tt.plans.trialFree", "Free during your trial — switch back any time.", "试用期间免费，可随时切换回来。"],
  ["tt.plans.confirmTitle", "Switch to {name}?", "切换到{name}？"],
  ["tt.plans.newPrice", "New price: {price} / month (prorated on your next invoice).", "新价格：每月 {price}（按比例计入下一张账单）。"],
  ["tt.plans.gain", "You get:", "你将获得："],
  ["tt.plans.lose", "No longer included:", "不再包含："],
  ["tt.plans.keep", "Keep as add-on ({price} / month)", "保留为扩展功能（每月 {price}）"],
  ["tt.plans.dropped", "Add-ons now included in {name} are removed from your bill.", "{name}已包含的扩展功能会从账单中移除。"],
  ["tt.plans.confirm", "Switch plan", "确认切换"],
  ["tt.plans.switched", "You're now on {name}", "已切换到{name}"],
  ["tt.plans.managed", "Your plan is managed by the Senvia POS team. Contact support to change it.", "你的方案由 Senvia POS 团队管理，如需更改请联系客服。"],
  ["tt.plans.subscribeOn", "Subscribe to {name}", "订阅{name}"],
  ["tt.addon.inPlan", "Included in your plan", "方案已包含"],
  ["tt.addon.nowIncluded", "Now included in your plan", "现已包含在方案中"],
  ["tt.addon.nowIncludedHint", "This used to be a paid add-on. It is part of your plan now — you keep it either way.", "这原是付费扩展功能，现已包含在你的方案中——无论如何你都会保留它。"],
  ["tt.addon.removeFromBill", "Remove from my bill", "从账单移除"],
  ["tt.addon.removeAll", "Remove all included add-ons from my bill", "从账单移除所有已包含的扩展功能"],
  ["tt.addon.removed", "Removed from your bill", "已从账单移除"],
  ["tt.addon.forBase", "Add-ons", "扩展功能"],
  ["tt.addon.fullHas", "All three are included in the Full plan.", "全功能版已全部包含这三项。"],
  ["tt.addon.manage", "Plan & billing", "方案与账单"],
  ["tt.signup.plan", "Plan to try", "试用方案"],
  ["tt.signup.planHint", "Free for {days} days, no card needed. You can switch plans any time.", "{days} 天免费，无需信用卡，可随时切换方案。"],
  ["tt.inv.offTitle", "Stock tracking is off", "库存追踪未开启"],
  ["tt.inv.offText", "Inventory is included in your plan. Turn on stock tracking to count stock, receive goods and deduct stock on every sale and service. Sales of products without stock will follow your negative-stock rule.", "库存已包含在你的方案中。开启库存追踪后即可盘点、收货，并在每次销售与服务时扣减库存。库存不足时的销售将依照你的负库存规则处理。"],
  ["tt.inv.turnOn", "Turn on stock tracking", "开启库存追踪"],
  ["tt.inv.turnOff", "Turn off stock tracking", "关闭库存追踪"],
  ["tt.inv.on", "Stock tracking is on", "库存追踪已开启"],
  ["tt.inv.offDone", "Stock tracking is off", "库存追踪已关闭"],
  ["tt.inv.ownerOnly", "Ask the owner to turn on stock tracking.", "请店主开启库存追踪。"],
  ["tt.inv.confirmOff", "Turn off stock tracking? Sales will no longer deduct stock. Your stock history is kept.", "关闭库存追踪？销售将不再扣减库存，库存记录会保留。"],
  ["tt.pf.nav", "Plans & add-ons", "方案与扩展"],
  ["tt.pf.title", "Plans & add-ons", "方案与扩展功能"],
  ["tt.pf.sub", "The price list salons see on the website, at sign-up and in Plan & billing. Price changes apply to new subscriptions after you publish them to Stripe; existing subscribers keep their price.", "官网、注册页与“方案与账单”显示的价目表。改价后需发布到 Stripe 才对新订阅生效；现有订阅保持原价。"],
  ["tt.pf.plans", "Plans", "方案"],
  ["tt.pf.addons", "Add-ons", "扩展功能"],
  ["tt.pf.retired", "Retired (hidden; salons that have it keep it)", "已停售（隐藏；已拥有的门店继续保留）"],
  ["tt.pf.salons", "{n} salons", "{n} 家门店"],
  ["tt.pf.onSale", "On sale", "在售"],
  ["tt.pf.hidden", "Hidden", "已隐藏"],
  ["tt.pf.unpublished", "Not published to Stripe", "未发布到 Stripe"],
  ["tt.pf.publish", "Publish prices to Stripe", "发布价格到 Stripe"],
  ["tt.pf.published", "Price list published", "价目表已发布"],
  ["tt.pf.edit", "Edit", "编辑"],
  ["tt.pf.editPlan", "Edit plan {name}", "编辑方案{name}"],
  ["tt.pf.editAddon", "Edit add-on {name}", "编辑扩展功能{name}"],
  ["tt.pf.name", "Name (English)", "名称（英文）"],
  ["tt.pf.nameZh", "Name (中文)", "名称（中文）"],
  ["tt.pf.desc", "Description (English)", "说明（英文）"],
  ["tt.pf.descZh", "Description (中文)", "说明（中文）"],
  ["tt.pf.price", "Price per month (USD)", "每月价格（美元）"],
  ["tt.pf.features", "Included features", "包含的功能"],
  ["tt.pf.branches", "Branches included", "包含分店数"],
  ["tt.pf.whatsapp", "WhatsApp messages / month", "每月 WhatsApp 讯息"],
  ["tt.pf.highlight", "Show as recommended", "标为推荐"],
  ["tt.pf.active", "On sale", "在售"],
  ["tt.pf.maxQty", "Maximum quantity", "最大数量"],
  ["tt.pf.saved", "Saved", "已保存"],
  ["tt.pf.needsPublish", "Saved — publish the new price to Stripe before salons can subscribe at it.", "已保存——请发布新价格到 Stripe，门店才能以新价格订阅。"],
  ["tt.pf.drop", "Remove now-included add-ons from Stripe bills", "从 Stripe 账单移除已包含的扩展功能"],
  ["tt.pf.dropPreview", "{n} salons still pay for add-ons their plan now includes.", "{n} 家门店仍在为方案已包含的扩展功能付费。"],
  ["tt.pf.dropNone", "No salon pays for an add-on its plan includes.", "没有门店为方案已包含的扩展功能付费。"],
  ["tt.pf.dropRun", "Remove them (prorated credit)", "移除（按比例退款）"],
  ["tt.pf.dropDone", "Removed from {n} salons", "已为 {n} 家门店移除"],
  ["tt.pf.byPlan", "Salons per plan", "各方案门店数"],
  ["tt.pf.grants", "Grants: {list}", "开通：{list}"],
  ["tt.site.website", "Website section", "网站版块"],
  ["tt.site.websiteHint", "The home-page section about the built-in shop website and the /website page.", "首页“内建店铺网站”版块与 /website 页面。"],
  ["tt.site.wEyebrow", "Small label", "小标签"],
  ["tt.site.wTitle", "Home section title", "首页版块标题"],
  ["tt.site.wSub", "Home section text", "首页版块文字"],
  ["tt.site.wHeadline", "Website page headline", "网站页标题"],
  ["tt.site.wIntro", "Website page intro", "网站页简介"],
  ["tt.site.wReasons", "Reasons", "理由"],
  ["tt.site.wReasonTitle", "Title", "标题"],
  ["tt.site.wReasonText", "Text", "内容"],
  ["tt.site.wSoon", "Show “Coming soon”", "显示“即将推出”"],
  ["tt.site.sec.website", "All-in-one incl. website", "一站式含网站"],
  ["tt.site.subs", "Subscriptions section", "订阅版块"],
  ["tt.site.subsHint", "The home-page section about subscriptions & recurring billing and the /subscriptions page.", "首页“订阅与自动扣款”版块与 /subscriptions 页面。"],
  ["tt.site.sHeadline", "Subscriptions page headline", "订阅页标题"],
  ["tt.site.sIntro", "Subscriptions page intro", "订阅页简介"],
  ["tt.site.sBenefits", "Benefits", "好处"],
  ["tt.site.sec.subs", "Subscriptions", "订阅"],
] as const;

export type TtKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<TtKey, string>;

export const taskT = { en: col(1), zh: col(2), ms: col(1) };
